module.exports = __webpack_public_path__ + "static/brandon1-00bbe4fcc4d3067d08840f69e1082bc4.jpg";